import type { WishlistFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { WishlistLineItemsFragmentFragmentDoc } from '@packages/gql/generated/shopping/WishlistLineItemsFragmentFragmentDoc';
import { makeFragmentData } from '@packages/gql/generated/shopping';
import { wishlistLineItemsMockData } from './lineItems';

export const wishlistMockData: WishlistFragmentFragment = {
  count: 8,
  lineItems: [makeFragmentData(wishlistLineItemsMockData[0], WishlistLineItemsFragmentFragmentDoc)],
};
export const wishlistEmptyMockData: WishlistFragmentFragment = {
  count: 0,
  lineItems: [],
};
